import React from 'react';
import PropTypes from 'prop-types';
import { PanelGroup } from 'react-bootstrap';

import PanelComponent from '../../../core/PanelComponent/PanelComponent';
import EndpointGridComponent from './EndpointGridComponent';

class CompatibilityPanelGroupComponent extends React.Component {
    onPanelEntering = (activeKey) => {
        this.setState({
            [`${activeKey}GridUpdate`]: true,
        });
    }

    render() {
        const {
            allApis,
            apisToShow,
            handleSelect,
            panelKey,
        } = this.props;

        let activeKey = this.props.activeKey;

        return <div className="panel-group">
            <PanelGroup
                accordion
                id={panelKey}
                activeKey={activeKey}
                onSelect={handleSelect}
            >
                {Object.keys(apisToShow).map((key) => {
                    const apiKeyList = apisToShow[key];

                    return <PanelComponent
                        title={key}
                        key={key}
                        eventKey={panelKey + key}
                        activeKey={activeKey}
                        eventProps={{
                            onEntering: () => this.onPanelEntering(activeKey),
                        }}
                    >
                        {apiKeyList.map((apiKey) => {
                            return <EndpointGridComponent
                                apiObject={allApis[apiKey]}
                                key={apiKey}
                            />
                        })}
                    </PanelComponent>
                })}
            </PanelGroup>
        </div>;
    }
}

CompatibilityPanelGroupComponent.propTypes = {
    activeKey: PropTypes.string,
    allApis: PropTypes.object.isRequired,
    apisToShow: PropTypes.object.isRequired,
    handleSelect: PropTypes.func.isRequired,
    panelKey: PropTypes.string.isRequired,
};

export default CompatibilityPanelGroupComponent;



// WEBPACK FOOTER //
// ./src/components/developerApi/developerSdk/Compatibility/CompatibilityPanelGroupComponent.js